/**
 * Canonical LaunchDarkly experiment keys for web-reg.
 *
 * This file is the single source of truth consumed by:
 *   - the app (re-exported from `src/stash/components/experiments/index.js`)
 *   - Playwright (`playwright/utilities/ab-testing.ts` via the
 *     `app-experiment-keys` path alias in `playwright/tsconfig.json`)
 *
 * Keep this module dependency-free so it can be imported from both compilers
 * (the app's `tsconfig.json` and `playwright/tsconfig.json`).
 */
export const EXPERIMENTS = {
	DEFAULT_TO_STASH_PLUS_TIER: 'web-2025-12-10-default-to-stash-plus-tier',
	BANK_LINK_EARLY: 'web-2026-04-bank-link-early',
	MILITARY_ONBOARDING_PROMO: 'web-2026-06-military-onboarding-promo',
	HERO_ONBOARDING: 'web-hero-onboarding-enabled',
	IOS_IAB_FIX: 'web-2026-ios-iab-fix',
} as const;

export type ExperimentName = keyof typeof EXPERIMENTS;
export type ExperimentFlagKey = (typeof EXPERIMENTS)[ExperimentName];
